import { actions } from '@/store/actions';
import { getters } from '@/store/getters';
import { state } from '@/store/state';
import { mutations } from './mutations';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { AuthenticationState } from './state';

const AuthenticationModule: Module<AuthenticationState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default AuthenticationModule;
export type { AuthenticationState };
